import { useState } from 'react';
import { CarouselButtons } from './carouselButtons/CarouselButtons';
import CarouselSlideImages from './slideImages/CarouselSlideImages';
import useCarouselElement from './hooks/useCarouselElement';
import { useCarouselImageRetriever } from '../../hooks/useCarouselImageRetriever';
import { CarouselContent } from './CarouselContent';

interface CarouselElementProps {
  slides: any[];
  autoPlay: boolean;

  textColor: string;
  buttonColor: string;
  buttonTextColor: string;
}

/**
 * CarouselElement component
 * this component is responsible for rendering the carousel
 * @param autoPlay - the autoplay state of the carousel
 * @param buttonColor - the color of the buttons
 * @param textColor - the color of the text
 * @param buttonTextColor - the color of the button text
 * @param slides - the slides of the carousel
 * @returns The carousel element what will be displayed on the preview
 */
export const CarouselElement = ({ autoPlay, buttonColor, textColor, buttonTextColor, slides }: CarouselElementProps) => {
  const [isHovered, setIsHovered] = useState(false);

  const { currentIndex, handleDotClick, nextSlide, prevSlide } = useCarouselElement({ slides, isHovered, autoPlay });
  const { images } = useCarouselImageRetriever({ slides });

  return (
    <div
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      onTouchStart={() => setIsHovered(true)}
      onTouchEnd={() => setIsHovered(false)}
      className='flex min-[350px]:flex-col lg:flex-row mx-auto bg-white w-full'
    >
      <CarouselSlideImages currentIndex={currentIndex} images={images} nextSlide={nextSlide} prevSlide={prevSlide} />
      <div className='min-[350px]:w-full lg:w-[35%] min-[350px]:h-[316px] md:h-[410px] lg:h-fit flex flex-col min-[350px]:px-4 min-[350px]:py-0 md:px-6 min-[1200px]:py-6'>
        <CarouselButtons slides={slides} currentIndex={currentIndex} handleDotClick={handleDotClick} nextSlide={nextSlide} prevSlide={prevSlide} buttonColor={buttonColor} autoPlay={autoPlay} isHovered={isHovered} />
        <CarouselContent slides={slides} currentIndex={currentIndex} textColor={textColor} buttonColor={buttonColor} buttonTextColor={buttonTextColor} />
      </div>
    </div>
  );
};
